import { TypographyOptions } from "@mui/material/styles/createTypography";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    gradientText: React.CSSProperties;
    gradientText2: React.CSSProperties;
  }

  // allow configuration using `createTheme()`
  interface TypographyVariantsOptions {
    gradientText?: React.CSSProperties;
    gradientText2?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    gradientText: true;
    gradientText2: true;
  }
}

export const typographyDark: TypographyOptions = {
  fontFamily: ["var(--global-font-family-primary)"].join(","),
  allVariants: {
    fontFamily: "var(--global-font-family-primary)",
  },
  gradientText: {
    background: "linear-gradient(90.2deg, #8428C0 0.06%, #903DB7 62.24%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    fontFamily: "var(--global-font-family-primary)",
  },
  gradientText2: {
    background: 'linear-gradient(90.2deg, #F1DBFF 0.06%, #9A6CF5 62.24%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    color: 'transparent',
    fontFamily: "var(--global-font-family-primary)"
  }
};
export const typographyLight: TypographyOptions = {
  fontFamily: ["var(--global-font-family-primary)"].join(","),
  allVariants: {
    fontFamily: "var(--global-font-family-primary)",
  },
  gradientText: {
    background: "#8428C0",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    fontFamily: "var(--global-font-family-primary)",
  },
  gradientText2: {
    background: 'linear-gradient(270deg, #5E5E9E -51.14%, #150025 39.58%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    color: 'transparent',
    fontFamily: "var(--global-font-family-primary)"
  }
};
